import React from 'react';
import { motion } from 'framer-motion';
export function OpeningHook() {
  return <section className="bg-navy py-20 px-6" data-id="element-214">
      <div className="max-w-3xl mx-auto" data-id="element-215">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.7
      }} className="border-l-4 border-amber-600 pl-6 md:pl-8 py-2" data-id="element-216">
          <p className="text-xl md:text-2xl text-slate-200 italic leading-relaxed mb-6 font-medium" data-id="element-217">
            Estás intentando almorzar, o quizás estás en el parque con los
            chicos, y de repente: vibración. Mirás la pantalla y el nombre que
            aparece te revuelve el estómago. No hace falta ni que abras el
            mensaje para saber que se viene un reclamo, un insulto encubierto o
            un planteo de hace cinco años.
          </p>
          <p className="text-xl md:text-2xl text-slate-200 italic leading-relaxed font-medium" data-id="element-218">
            En tres segundos, tu paz se terminó. Te quedás rumiando la bronca,
            texteando defensas que no sirven para nada y perdiéndote el momento
            con tus hijos porque tu cabeza está atrapada en una pelea digital
            que no tiene fin.
          </p>
        </motion.div>
      </div>
    </section>;
}